import { useContext } from "react";
import { ActionType } from "../assets/constants/constants";
import { AppContext } from "../context/AppProvider";
import { apis } from "../services/alm";

const useCatelog = () => {
  const { dispatch} = useContext(AppContext);
  const getCatelog = async (type:string) => {
    try {
      const result:any = await apis.fetchCatalogs();
      const arr=[]
      arr.push(...result.data);
      let isTrue = result?.links?.next;
      while (isTrue) {
        const result: any = await apis.nextBaseUrl(isTrue);
        arr.push(...result.data);
        isTrue = result?.links?.next ? result?.links?.next : false;
      }
      const catalogId = arr?.flat(1)?.filter((res: any) => {
        return res?.attributes?.name === type;
      })[0];
      dispatch({
        type: ActionType.SET_CATELOG, 
        payload: {
          catlogList :arr, 
          fundamenalCatlogId:catalogId?.id
        }
      });
    } catch (e) {
      console.error(e);
    }
  };
    
  return {getCatelog};
};

export default useCatelog;
